import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ClassificationField} from "../../../../../../models/classification-field";
import { Registration } from "../../../../../../models/registration";
import {ClassificationControllerService} from "../../../../../../services/classifications-controller/classification-controller.service";
import {Store} from "../../../../../../services/store.service";

@Component({
  selector: "field-options",
  templateUrl: "./field-options.component.html",
})
export class FieldOptionsComponent implements OnInit {
  @Input() public serviceId: string;
  @Input() public options: any;
  @Input() public fieldOptions: any;
  @Input() public jsonDeterminants: string;
  @Input() public tagOptions: any = [];
  @Input() public allfields: any;
  @Input() public fields: any;
  @Input() public guides: any[];
  @Input() public guide: any;
  @Input() public isGuideForm: boolean;
  @Input() public notifications: any[];
  @Input() public tags: any[];
  @Input() public classificationsList: any[] = [];
  @Input() public relatedDeterminants: any = [];
  @Input() public isComplexGrid: boolean;
  @Input() public isEditGrid: boolean;
  @Input() public registrations: Registration[];
  @Input() public context: string = "options";
  @Input() public determinantTooltip: string = "Determines if item appears or not";
  @Output() public dataChanged = new EventEmitter();
  @Output() public saveData = new EventEmitter();
  public newSelection: string;
  public classificationFields: ClassificationField[] = [];

  constructor(public store: Store, private classificationControllerService: ClassificationControllerService) {}

  public ngOnInit() {
    /*
    if (!this.options.format) {
      this.updateDateTime(this.options.enableDate, this.options.enableTime);
    }
    this.updateDateFormat(this.options.enableDate);
    */
   this.updateDateTime(this.options.enableDate, this.options.enableTime);
  }

  public saveForm() {
    this.saveData.emit();
  }

  public updateGroup($event) {
      this.fieldOptions.jsonDeterminants = $event.jsonString;
  }

  public countNumberOfDeterminants() {
    return FieldOptionsComponent.countNumberOfDeterminantsFromStringJson(this.fieldOptions.jsonDeterminants);
  }

  public static countNumberOfDeterminantsFromStringJson(jsonDeterminantsAsText: string) {
    if (jsonDeterminantsAsText) {
      const parse = JSON.parse(jsonDeterminantsAsText);
      if (parse.length === 0) {
        return 0;
      }
      let num = 0;
      parse.forEach((it) => num += it.items.length);
      return num;
    }
    return 0;
  }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

  public updateTimeFormat(isTimeEnabled) {
    if (this.options.enableDate) {
      if (isTimeEnabled) {
        this.options.format += " hh:mm";
      } else {
        this.options.format = this.options.format.slice(0, -(" hh:mm").length);
      }
    } else {
      if (isTimeEnabled) {
        this.options.format = "hh:mm";
      } else {
        this.options.format = "";
      }
    }
  }

  public updateDateFormat(isDateEnabled) {
    if (this.options.enableTime) {
      if (isDateEnabled) {
        this.options.format = "dd-MM-yyyy " + this.options.format;
      } else {
        this.options.format = this.options.format.substring("dd-MM-yyyy ".length);
      }
    } else {
      if (isDateEnabled) {
        this.options.format = "dd-MM-yyyy";
      } else {
        this.options.format = "";
      }
    }
  }

  public updateDateTime(dateEnabled, timeEnabled) {
    if (dateEnabled && timeEnabled) {
      this.options.format = "dd-MM-yyyy hh:mm";
    } else if (dateEnabled) {
      this.options.format = "dd-MM-yyyy";
    } else if (timeEnabled) {
      this.options.format = "hh:mm";
    } else {
      this.options.format = "";
    }
  }

  public getFieldOptionsRegistrationsLength(fieldOptions) {
      const isPresent = fieldOptions && fieldOptions.registrations && fieldOptions.registrations.length;
      return isPresent ? fieldOptions.registrations.length : 0;
  }

  public closeDetLayer() {
    this.store.state.common.determinantSection.reset();
  }

  public loadCatalogueFields(id: any) {
      this.classificationControllerService.getClassificationsByType(id).subscribe(
          (data) => this.classificationFields = data,
      );
    }
}
